import { render, staticRenderFns } from "./desktop-user-review.vue?vue&type=template&id=b50202d8&"
import script from "./desktop-user-review.vue?vue&type=script&lang=js&"
export * from "./desktop-user-review.vue?vue&type=script&lang=js&"
import style0 from "./desktop-user-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports